import { useTranslation } from 'react-i18next';
import { DEFAULT_LANGUAGE, SITE_NAME } from '../config/constants';

export function getLanguageByPath(path: string, fallback = DEFAULT_LANGUAGE) {
  return /^\/[a-z]{2}(\/.*)?$/g.test(path)
    ? path.replace(/^\/([a-z]{2})(\/.*)?/, '$1')
    : fallback;
}

export function getDocumentTitle(title: string) {
  if (!title) {
    return SITE_NAME;
  }

  return `${title} | ${SITE_NAME}`;
}

export function isDateBeforeToday(date: Date) {
  // Initialize today at midnight
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  return today.getTime() > date.getTime();
}

export function dateFormatter(date: Date | string, lang: string, shortMonth = false) {
  const asJsDate = new Date(date);

  return new Intl.DateTimeFormat(lang, {
    day: 'numeric',
    month: shortMonth ? 'short' : 'long',
    year: 'numeric',
  }).format(asJsDate);
}

function getFromMenuRecursive(menu: any, menuLinkName: string) {
  if (!menu) {
    return null;
  }

  const filtered = menu.filter((menuItem: any) => menuItem.getIn(['link', 'title']) === menuLinkName);

  if (filtered.size === 0) {
    for (let index = 0; index < menu.size; index++) {
      const childMenu = menu.get(index);

      const childMenuTree = childMenu.get('subtree', null);

      if (childMenuTree !== null) {
        const subtreeMenuData: any = getFromMenuRecursive(childMenuTree, menuLinkName);

        if (subtreeMenuData) {
          return subtreeMenuData;
        }
      }
    }
  }

  return filtered.getIn([0, 'link', 'url'], null);
}

export function getOverviewUrlFromMenu(menu: any, type: string) {
  const { t } = useTranslation();

  const typeMapping: any = {
    articles: 'Nieuws',
    themes: t('overviews.themes'),
    publications: 'Publicaties',
    partners: 'Onze leden',
    codes: 'Codes',
    magazines: 'Ons Net NL magazine',
    vacancies: 'Werken bij',
  };
  const usableTypeName = typeMapping[type];

  return getFromMenuRecursive(menu, usableTypeName);
}
